/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { TickerAuctionCatalogPartDto } from '../models/ticker-auction-catalog-part-dto';

@Injectable({
  providedIn: 'root',
})
export class GeneratedTickerAuctionCatalogPartService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation findActiveTicketAuctionCatalogParts
   */
  static readonly FindActiveTicketAuctionCatalogPartsPath = '/api/ticker/auction-catalog-parts/active';

  /**
   * Finds all active parts.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findActiveTicketAuctionCatalogParts()` instead.
   *
   * This method doesn't expect any request body.
   */
  findActiveTicketAuctionCatalogParts$Response(params?: {
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<TickerAuctionCatalogPartDto>>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedTickerAuctionCatalogPartService.FindActiveTicketAuctionCatalogPartsPath, 'get');
    if (params) {
      rb.header('X-API-Version', params['X-API-Version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TickerAuctionCatalogPartDto>>;
      })
    );
  }

  /**
   * Finds all active parts.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findActiveTicketAuctionCatalogParts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findActiveTicketAuctionCatalogParts(params?: {
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<Array<TickerAuctionCatalogPartDto>> {

    return this.findActiveTicketAuctionCatalogParts$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<TickerAuctionCatalogPartDto>>) => r.body as Array<TickerAuctionCatalogPartDto>)
    );
  }

  /**
   * Path part for operation getTicketAuctionCatalogPart
   */
  static readonly GetTicketAuctionCatalogPartPath = '/api/ticker/auction-catalog-parts/{id}';

  /**
   * Gets a auction catalog part by its id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTicketAuctionCatalogPart()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTicketAuctionCatalogPart$Response(params: {
    id: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<TickerAuctionCatalogPartDto>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedTickerAuctionCatalogPartService.GetTicketAuctionCatalogPartPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.header('X-API-Version', params['X-API-Version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TickerAuctionCatalogPartDto>;
      })
    );
  }

  /**
   * Gets a auction catalog part by its id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTicketAuctionCatalogPart$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTicketAuctionCatalogPart(params: {
    id: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<TickerAuctionCatalogPartDto> {

    return this.getTicketAuctionCatalogPart$Response(params,context).pipe(
      map((r: StrictHttpResponse<TickerAuctionCatalogPartDto>) => r.body as TickerAuctionCatalogPartDto)
    );
  }

}
